import { CarriersIcon } from '../icons'

export default {
  id: 'carriers',
  title: {
    en: 'Carriers',
    ar: 'ناقلات المياه'
  },
  Icon: CarriersIcon,
  description: {
    en: `<p>Water carriers move large amounts of water across long distances.</p><p>The King Abdullah Canal runs parallel to the Jordan River and is the country's largest irrigation canal system. The Disi Conveyor is Jordan’s longest carrier (at 320 km), moving water from the Disi aquifer in the south across ten governorates.</p>`,
    ar: `<p>تقوم نواقل المياه بنقل كمّيّات كبيرة من المياه عبر مسافات طويلة.</p><p>تجري مياه قناة الملك عبدالله بشكل موازٍ لنهر الأردن وتمثّل أكبر نظام ريٍّ قَنَويٍّ في الأردن. يُمثِّل ناقل الديسي أطول ناقل في الأردن (بطول 320 كم) حيث ينقل المياه من حوض مياه الدّيسي الجوفي في الجنوب عابراً عشرة محافظاتٍ.</p>`
  },
  icon: '../canal.svg',
  entries: [
    {
      id: 'kac',
      title: { en: 'King Abdullah Canal', ar: 'قناة الملك عبداللة' },
      year: '1957 - 1987',
      length: '110',
      capacity: '90',
      points: [
        { x: '5', y: '0' },
        { x: '5', y: '20' },
        { x: '5', y: '40' },
        { x: '5', y: '60' },
        { x: '5', y: '80' },
        { x: '5', y: '100' },
        { x: '5', y: '120' },
        { x: '5', y: '140' },
        { x: '5', y: '160' },
        { x: '5', y: '180' },
        { x: '5', y: '200' },
        { x: '5', y: '220' },
        { x: '5', y: '240' },
        { x: '5', y: '260' },
        { x: '5', y: '280' },
        { x: '5', y: '300' },
        { x: '5', y: '320' },
        { x: '5', y: '340' },
        { x: '5', y: '360' },
        { x: '5', y: '380' },
        { x: '5', y: '400' }
      ]
    },
    {
      id: 'zara',
      title: {
        en: "Zara-Ma'in - Abu Alanda",
        ar: 'زارا ماعين - ابو علندا'
      },
      year: '2007',
      capacity: '43.8',
      length: '38.7',
      points: [
        { x: '10', y: '50' },
        { x: '30', y: '45' },
        { x: '50', y: '40' },
        { x: '70', y: '35' },
        { x: '90', y: '30' },
        { x: '110', y: '25' },
        { x: '130', y: '20' },
        { x: '150', y: '15' },
        { x: '170', y: '10' }
      ]
    },
    {
      id: 'zai',
      title: { en: 'Zai - Dabouq', ar: 'زي - دابوق' },
      year: '2001',
      capacity: '91.25',
      length: '15.5',
      points: [
        { x: '10', y: '0' },
        { x: '25', y: '10' },
        { x: '40', y: '20' },
        { x: '55', y: '30' },
        { x: '70', y: '40' },
        { x: '85', y: '50' },
        { x: '100', y: '60' }
      ]
    },
    {
      id: 'disi',
      title: { en: 'Disi - Amman', ar: 'الديسي - عمان' },
      year: '2009 - 2013',
      length: '320',
      capacity: '100',
      points: [
        { x: '5', y: '1280' },
        { x: '5', y: '1260' },
        { x: '5', y: '1240' },
        { x: '5', y: '1220' },
        { x: '5', y: '1200' },
        { x: '5', y: '1180' },
        { x: '5', y: '1160' },
        { x: '5', y: '1140' },
        { x: '5', y: '1120' },
        { x: '5', y: '1100' },
        { x: '5', y: '1080' },
        { x: '5', y: '1060' },
        { x: '5', y: '1040' },
        { x: '5', y: '1020' },
        { x: '5', y: '1000' },
        { x: '5', y: '980' },
        { x: '5', y: '960' },
        { x: '5', y: '940' },
        { x: '5', y: '920' },
        { x: '5', y: '900' },
        { x: '5', y: '880' },
        { x: '5', y: '860' },
        { x: '5', y: '840' },
        { x: '5', y: '820' },
        { x: '5', y: '800' },
        { x: '5', y: '780' },
        { x: '5', y: '760' },
        { x: '5', y: '740' },
        { x: '5', y: '720' },
        { x: '5', y: '700' },
        { x: '5', y: '680' },
        { x: '5', y: '660' },
        { x: '5', y: '640' },
        { x: '5', y: '620' },
        { x: '5', y: '600' },
        { x: '5', y: '580' },
        { x: '5', y: '560' },
        { x: '5', y: '540' },
        { x: '5', y: '520' },
        { x: '5', y: '500' },
        { x: '5', y: '480' },
        { x: '5', y: '460' },
        { x: '5', y: '440' },
        { x: '5', y: '420' },
        { x: '5', y: '400' },
        { x: '5', y: '380' },
        { x: '5', y: '360' },
        { x: '5', y: '340' },
        { x: '5', y: '320' },
        { x: '20', y: '305' },
        { x: '35', y: '285' },
        { x: '50', y: '270' },
        { x: '65', y: '255' },
        { x: '80', y: '240' }
      ]
    }
  ]
}
